export const DEFAULT_CONVERSATION_PAGE_SIZE = 15;
export const DEFAULT_PUBLIC_CONVERSATION_PAGE_SIZE = 9;
